const TICKER_SELECTOR = '.ticker__track';
const CLONE_ATTRIBUTE = 'data-ticker-clone';
const SPEED_PIXELS_PER_SECOND = 60;
const MAX_EXTRA_SETS = 10;
const RESIZE_DELAY_MS = 150;

function isElementorEditor() {
    return document.body.classList.contains('elementor-editor-active');
}

function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function appendClonedSet(track, originalItems) {
    originalItems.forEach((originalItem) => {
        const clonedItem = originalItem.cloneNode(true);
        clonedItem.setAttribute(CLONE_ATTRIBUTE, '');
        clonedItem.setAttribute('aria-hidden', 'true');
        track.appendChild(clonedItem);
    });
}

function startTicker(track) {
    track.getAnimations().forEach((animation) => animation.cancel());
    track.querySelectorAll('[' + CLONE_ATTRIBUTE + ']').forEach((clonedItem) => clonedItem.remove());

    const originalItems = Array.from(track.children);

    if (originalItems.length === 0) {
        return;
    }

    appendClonedSet(track, originalItems);

    const setWidth = track.children[originalItems.length].offsetLeft - originalItems[0].offsetLeft;

    if (!(setWidth > 0)) {
        return;
    }

    let extraSets = 0;

    while (track.scrollWidth < window.innerWidth + setWidth && extraSets < MAX_EXTRA_SETS) {
        appendClonedSet(track, originalItems);
        extraSets += 1;
    }

    track.animate(
        [{ transform: 'translateX(0)' }, { transform: 'translateX(-' + setWidth + 'px)' }],
        { duration: (setWidth / SPEED_PIXELS_PER_SECOND) * 1000, iterations: Infinity, easing: 'linear' }
    );
}

function startAllTickers() {
    if (isElementorEditor() || prefersReducedMotion()) {
        return;
    }

    document.querySelectorAll(TICKER_SELECTOR).forEach(startTicker);
}

let lastViewportWidth = window.innerWidth;
let resizeTimer = 0;

window.addEventListener('load', startAllTickers);

window.addEventListener('resize', () => {
    if (window.innerWidth === lastViewportWidth) {
        return;
    }

    lastViewportWidth = window.innerWidth;
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(startAllTickers, RESIZE_DELAY_MS);
});
